var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgOk = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Ok")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/lined/ok",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ok"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,33.5857865 L10.0404401,25.1262265 C9.64991579,24.7357022 9.01675081,24.7357022 8.62622652,25.1262265 C8.23570223,25.5167508 8.23570223,26.1499158 8.62622652,26.5404401 L17.7928932,35.7071068 C18.1834175,36.0976311 18.8165825,36.0976311 19.2071068,35.7071068 L39.3737735,15.5404401 C39.7642978,15.1499158 39.7642978,14.5167508 39.3737735,14.1262265 C38.9832492,13.7357022 38.3500842,13.7357022 37.9595599,14.1262265 L18.5,33.5857865 Z",
    id: "Path",
    fill: "#0A1428",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ok.28889477.svg";
export { ForwardRef as ReactComponent };